import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Environment } from 'data/terra/Environment';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { fetchModuleIntegrations } from '../../moduleConfig/actions';
import { AppSelectorState } from '../reducer';

export const selectEnv = (
  env: Environment
): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch,
  getState
) => {
  const { selectedAppVersion } = getState().appSelector;

  dispatch({
    type: SELECT_ENV,
    selectedEnv: env,
  } as SelectEnvAction);

  selectedAppVersion?.id &&
    dispatch(fetchModuleIntegrations(selectedAppVersion.id, env.id));
};

export const SELECT_ENV = 'SELECT_ENV';

export interface SelectEnvAction {
  type: typeof SELECT_ENV;
  selectedEnv: Environment;
}

export const selectEnvDelegate: DelegateMapEntry<
  SelectEnvAction,
  AppSelectorState
> = {
  [SELECT_ENV]: (
    state: AppSelectorState,
    action: SelectEnvAction
  ): AppSelectorState => {
    return {
      ...state,
      selectedEnv: action.selectedEnv,
    };
  },
};
